import {
    Flex,
    Button,
    Spacer,
    useDisclosure,
    Box,
    HStack
} from '@chakra-ui/react';

import {
    VscVr,
    VscFlame,
    VscFoldUp
} from 'react-icons/vsc';

import { CheckIcon } from '@chakra-ui/icons';

import Const from '../Constants';

import CatchUpModal from '../Views/CatchUpModal';

import { useTasksStore } from '../Stores/TasksStore';

const TaskTopBar = ({
    auth,
    appMode,
    setAppMode
  }) => {
    // Filter states
    const showCompletedTasks = useTasksStore((state) => state.showCompletedTasks);
    const setShowCompletedTasks = useTasksStore((state) => state.setShowCompletedTasks);

    const showUrgentTasks = useTasksStore((state) => state.showUrgentTasks);
    const setShowUrgentTasks = useTasksStore((state) => state.setShowUrgentTasks);

    const showImportantTasks = useTasksStore((state) => state.showImportantTasks);
    const setShowImportantTasks = useTasksStore((state) => state.setShowImportantTasks);

    // Catch up modal state
    const { isOpen, onOpen, onClose } = useDisclosure();

    function onCatchUp() {
        onOpen();
    }

    const handleModalClose = () => {
        onClose();
    };

    async function handleAIUpNextTask() {
        try {
            // setIsAISummaryLoading(true);

            // Ask server for AI summary

            const idToken = await auth.currentUser.getIdToken();
            const theURL = `${process.env.REACT_APP_BASE_URL}/tasks/upnext`;
        
            const response = await fetch(theURL, {
                headers: new Headers({
                    Authorization: idToken
                }),
            });
            const responseJson = await response.json();

            console.log('AI Up Next Task:', responseJson);

            // setAiSummary(responseJson.summary);
        } catch (error) {
            console.error(error.message);
        } finally {
            // setIsAISummaryLoading(false);
        }
    }

    function onUpNext() {
        handleAIUpNextTask();
    }

    return (
        <>
        <Flex
            justifyContent={Const.Left}
            alignItems={Const.sCenter}
            padding={Const.kPadding}
            background={Const.Gray46}
            width={'100%'}
            borderBottom={'1px solid'}
            borderColor={Const.Gray64}
        >
            { appMode === Const.sTasks &&
            <>
            <HStack>
                <Button
                    leftIcon={<CheckIcon />}
                    size={Const.SM}
                    height={'30px'}
                    background={showCompletedTasks ? Const.DoneColor : Const.Gray36}
                    color={Const.Gray165}
                    _hover={{ background: showCompletedTasks ? Const.DoneLightColor : Const.Gray69 }}
                    fontSize={Const.XS}
                    onClick={() => {
                        setShowCompletedTasks(auth, !showCompletedTasks);
                    }}>
                    { showCompletedTasks ? 'Show completed' : 'Show completed' }
                </Button>
                <Button
                    leftIcon={<VscFlame/>}
                    size={Const.SM}
                    height={'30px'}
                    background={showUrgentTasks ? Const.DoneColor : Const.Gray36}
                    color={Const.Gray165}
                    _hover={{ background: showUrgentTasks ? Const.DoneLightColor : Const.Gray69 }}
                    fontSize={Const.XS}
                    onClick={() => {
                        setShowUrgentTasks(auth, !showUrgentTasks);
                    }}>
                    { showUrgentTasks ? 'Show urgent' : 'Show urgent' }
                </Button>
                <Button
                    leftIcon={<VscFoldUp/>}
                    size={Const.SM}
                    height={'30px'}
                    background={showImportantTasks ? Const.DoneColor : Const.Gray36}
                    color={Const.Gray165}
                    _hover={{ background: showImportantTasks ? Const.DoneLightColor : Const.Gray69 }}
                    fontSize={Const.XS}
                    onClick={() => {
                        setShowImportantTasks(auth, !showImportantTasks);
                    }}>
                    { showImportantTasks ? 'Show important' : 'Show important' }
                </Button>
            </HStack>
            <Spacer/>
            { false &&
            <Button
                leftIcon={
                    <Box fontSize="18px" fontWeight={'bold'}> {/* You can also use 'xl' or a specific size like '20px' */}
                        <VscVr />
                    </Box>
                }
                size={Const.SM}
                height={'30px'}
                marginLeft={2}
                background={Const.ActiveColor}
                color={Const.White}
                _hover={{ background: Const.ActiveLightColor }}
                fontSize={Const.XS}
                onClick={onUpNext}>
                Up next
            </Button>
            }
            <Button
                leftIcon={
                    <Box fontSize="18px" fontWeight={'bold'}> {/* You can also use 'xl' or a specific size like '20px' */}
                        <VscVr />
                    </Box>
                }
                size={Const.SM}
                height={'30px'}
                marginLeft={2}
                background={Const.DoneColor}
                color={Const.White}
                _hover={{ background: Const.DoneLightColor }}
                fontSize={Const.XS}
                onClick={onCatchUp}>
                Catch up
            </Button>
            
            </>            
            }
        </Flex>
        <CatchUpModal
            auth={auth}
            isOpen={isOpen}
            onClose={handleModalClose}
            setAppMode={setAppMode}
        />
        </>
    );
};

export default TaskTopBar;
